import { useState, useContext } from "react";
import {
  Input,
  Textarea,
  Button,
  Card,
  CardBody,
  Select,
  SelectItem,
} from "@heroui/react";
import { BackendContext } from "../Context/BackendContext";
import AppNavbar from "../Components/AppNavbar";

const SupportPage = () => {
  const { userProfile, createSupportCase } = useContext(BackendContext);
  const isLoggedIn = !!userProfile?.username;

  const [subject, setSubject] = useState("Bug Report");
  const [message, setMessage] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");

  const handleSubmit = async () => {
    if (!message.trim()) {
      setStatus("Please write a message.");
      return;
    }

    setLoading(true);
    setStatus("");

    try {
      const supportCase = {
        subject,
        category: subject,
        message,
        userSub: userProfile?.sub,
        email: userProfile?.email,
      }

      const response = await createSupportCase(supportCase); // Simulate API

      if(response) {
        setStatus("Your message has been sent. Thank you!");
      }else {
        setStatus("There was an error sending support case");
      }
      setMessage("");
    } catch (error) {
      console.error("Failed to send support message:", error);
      setStatus("There was a problem sending your message.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 text-white">
      <AppNavbar />

      <div className="max-w-2xl mx-auto pt-32 px-4">
        <Card className="bg-slate-800 border border-zinc-700">
          <CardBody className="space-y-6">
            <h1 className="text-2xl font-bold text-center">🛠️ Support</h1>
            <p className="text-sm text-zinc-300 text-center">
              Have a bug to report, an improvement idea, or just want to reach out?
            </p>

            <div className="space-y-4">
              <div>
                <label className="text-sm text-zinc-400 mb-1 block">Category</label>
                <Select
                  selectedKeys={[subject]}
                  onSelectionChange={(keys) => setSubject(Array.from(keys)[0])}
                  classNames={{
                    trigger: "bg-gray-900 text-white",
                    popoverContent: "bg-gray-900 text-white"
                  }}
                >
                  <SelectItem key="Bug Report">Bug Report</SelectItem>
                  <SelectItem key="Feedback">Feedback</SelectItem>
                  <SelectItem key="Feature Request">Feature Request</SelectItem>
                  <SelectItem key="Other">Other</SelectItem>
                </Select>
              </div>

              {!isLoggedIn && (
                <div>
                  <label className="text-sm text-zinc-400 mb-1 block">Your Email</label>
                  <Input
                    type="email"
                    placeholder="you@example.com"
                    value={userEmail}
                    onChange={(e) => setUserEmail(e.target.value)}
                  />
                </div>
              )}

              <div>
                <label className="text-sm text-zinc-400 mb-1 block">Your Message</label>
                <Textarea
                  placeholder="Describe your issue or suggestion..."
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  rows={6}
                  classNames={{
                    inputWrapper: "bg-gray-900 text-white"
                  }}
                />
              </div>

              <Button
                className="w-full bg-indigo-600 hover:bg-indigo-700"
                isLoading={loading}
                onPress={handleSubmit}
              >
                Send Message
              </Button>

              {status && (
                <p
                  className={`text-sm text-center ${
                    status.startsWith("Your message") ? "text-green-400" : "text-red-400"
                  }`}
                >
                  {status}
                </p>
              )}
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default SupportPage;
